var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C7.0365 0 3 4.0365 3 9C3 15.2385 11.124 23.4345 11.469 23.781C11.616 23.9265 11.808 24 12 24C12.192 24 12.384 23.9265 12.531 23.781C12.876 23.4345 21 15.2385 21 9C21 4.0365 16.9635 0 12 0ZM12 22.1655C10.209 20.2485 4.5 13.7655 4.5 9C4.5 4.8645 7.8645 1.5 12 1.5C16.1355 1.5 19.5 4.8645 19.5 9C19.5 13.761 13.791 20.2485 12 22.1655Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5C9.519 4.5 7.5 6.519 7.5 9C7.5 11.481 9.519 13.5 12 13.5C14.481 13.5 16.5 11.481 16.5 9C16.5 6.519 14.481 4.5 12 4.5ZM12 12C10.3455 12 9 10.6545 9 9C9 7.3455 10.3455 6 12 6C13.6545 6 15 7.3455 15 9C15 10.6545 13.6545 12 12 12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.cc7d8e1742df43d556a6fabd9e578d02.svg";
export { ForwardRef as ReactComponent };